import anime from 'animejs';

const overlay = {
    init() {
        const containers = document.querySelectorAll('.js-overlay-container');
        containers.forEach((container) => {
            const trigger = container.querySelector('.js-overlay-trigger');
            const overlayContent = container.querySelector('.js-overlay-content');
            const background = container.querySelector('.js-overlay-background');
            let isOpen = false;

            trigger.addEventListener('keyup', (event) => {
                event.preventDefault();

                if (event.keyCode === 86) {
                    this.open(overlayContent, background);
                    isOpen = true;
                } else if (event.keyCode === 27) {
                    this.close(overlayContent, background);
                    isOpen = false;
                }
            });

            trigger.addEventListener('click', () => {
                if (!isOpen) {
                    this.open(overlayContent, background);
                    isOpen = true;
                } else {
                    this.close(overlayContent, background);
                    isOpen = false;
                }
            });
        });
    },

    open(content, background) {
        const contentElement = content;
        const backgroundElement = background;

        contentElement.classList.add('active');
        backgroundElement.style.opacity = 1;
        contentElement.style.transform = 'translateY(0)';

        anime({
            targets: content,
            translateY: 0,
            duration: 100,
            easing: 'easeInOutExpo',
        });

        document.querySelector('body').style.overflow = 'hidden';
    },

    close(content, background) {
        const contentElement = content;
        const backgroundElement = background;

        const timeline = anime.timeline({
            duration: 200,
            easing: 'linear',
            complete: (() => {
                contentElement.classList.remove('active');
            }),
        });

        timeline.add({
            targets: contentElement,
            translateY: (document.body.clientWidth),
        }).add({
            targets: backgroundElement,
            opacity: 0,
        });

        document.querySelector('body').style.overflow = '';
    },
};

export default overlay;
